import React from "react";
import CloudIcon from "../images/cloud-icon.png";
import PhoneIcon from "../images/phone-icon.png";
import PiggyIcon from "../images/piggy-icon.png";
import VMock from "../images/vhealth-mock.png";
import VMock1 from "../images/vhealth-mock1.png";
import VMock2 from "../images/vhealth-mock2.png";

export default function MarketingContainer() {
  return (
    <div>
      <div className="container marketing">
        {/* <!-- Three columns of text below the carousel --> */}
        <div className="row">
          <div className="col-lg-4">
            <img
              className="mb-5"
              src={CloudIcon}
              alt="Generic placeholder image1"
              width="140"
              height="140"
            />
            <h2>Security and Compliance first</h2>
            <p>
              Our software is a safe and secure cloud solution to your digital
              problems.
            </p>
            <p>
              <a
                className="btn btn-success"
                href="https://www.google.com"
                role="button"
              >
                Book a Demo
              </a>
            </p>
          </div>
          <div className="col-lg-4">
            <img
              className="mb-5"
              src={PhoneIcon}
              alt="Generic placeholder image2"
              width="140"
              height="140"
            />
            <h2>Mobile goes everywhere</h2>
            <p>
              Telemedicine, Practice Management, Patient Portal, Website & Apps
              all you need just one touch away
            </p>
            <p>
              <a
                className="btn btn-success"
                href="https://www.google.com"
                role="button"
              >
                Book a Demo
              </a>
            </p>
          </div>
          <div className="col-lg-4">
            <img
              className="mb-5"
              src={PiggyIcon}
              alt="Generic placeholder image3"
              width="140"
              height="140"
            />
            <h2>Save Time & Money</h2>
            <p>
              Grow your revenues including telemedicine services. Your patients
              and your medical staff will feel cared with video calls, text
              consultations and care plans
            </p>
            <p>
              <a
                className="btn btn-success"
                href="https://www.google.com"
                role="button"
              >
                Book a Demo
              </a>
            </p>
          </div>
        </div>

        {/* <!-- START THE FEATURETTES --> */}

        <hr className="featurette-divider" />

        <div className="row featurette">
          <div className="col-md-7">
            <h2 className="featurette-heading">Mobile Integration</h2>
            <p className="lead">
              Making it convenient for you to manage your patients and practice.
              Mobile apps for both providers and patients. Accessibility to
              manage your practice and services as well as the convenience for
              patients to stay in touch.
            </p>
            <button type="button" class="btn btn-primary">
              Book a Demo
            </button>
          </div>
          <div className="col-md-5">
            <img
              className="img-fluid"
              src={VMock}
              alt="Generic placeholder image5"
            />
          </div>
        </div>

        <hr className="featurette-divider" />

        <div className="row featurette">
          <div className="col-md-7 order-md-2">
            <h2 className="featurette-heading">Patient Health Records</h2>
            <p className="lead">
              The right information leads to better decisions. Make informed
              decisions about your patients' care with access to their health
              records. Comprehensive health records of your patients that are
              accessible to you during consultations.
            </p>
            <button type="button" class="btn btn-primary">
              Book a Demo
            </button>
          </div>
          <div className="col-md-5 order-md-1">
            <img
              className="img-fluid"
              src={VMock1}
              alt="Generic placeholder image4"
            />
          </div>
        </div>

        <hr className="featurette-divider" />

        <div className="row featurette">
          <div className="col-md-7">
            <h2 className="featurette-heading">Video Consultation</h2>
            <p className="lead">
              Meet more patients every day. A quick and efficient service to
              follow-up with your patients, wherever they may be. A great way
              for elderly patients, patients with disabilities and those located
              far away to connect with you.
            </p>
          </div>
          <div className="col-md-5">
            <img
              className="img-fluid"
              src={VMock2}
              alt="Generic placeholder image6"
            />
          </div>
        </div>

        <hr className="featurette-divider" />
      </div>
    </div>
  );
}
